import request from '@/utils/request'

// 业务工单概况
export function businessOrderStatistics(params) {
  return request({
    url: '/disJobOrder/businessOrderStatistics',
    method: 'get',
    params
  })
}

// 咨询工单概况
export function adviceOrderStatistics(params) {
  return request({
    url: '/disJobOrderLog/adviceOrderStatistics',
    method: 'get',
    params
  })
}

// 投诉工单概况
export function complaintOrderStatistics(params) {
  return request({
    url: '/disJobOrderLog/complaintOrderStatistics',
    method: 'get',
    params
  })
}

// 工单类型占比
export function businessOrderPercent(params) {
  return request({
    url: '/disJobOrder/businessOrderPercent',
    method: 'get',
    params
  })
}

// 处置人前五名工单数
export function businessOrderTop5(params) {
  return request({
    url: '/disJobOrder/businessOrderTop5',
    method: 'get',
    params
  })
}

// 工单趋势
export function businessOrderTrend(params) {
  return request({
    url: '/disJobOrder/businessOrderTrend',
    method: 'get',
    params
  })
}

// 支付情况
export function payOrderStatistics(params) {
  return request({
    url: '/disJobOrderLog/payOrderStatistics',
    method: 'get',
    params
  })
}
